import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import server from '../services/server';
import { useAuth } from '../context/AuthContext';

export default function AuthRedirect() {
    const [params] = useSearchParams();
    const navigation = useNavigate();
    const { Login } = useAuth();
    const [errorMessage, setErrorMessage] = useState(null);

    useEffect(() => {
        const authenticate = async () => {
            try {
                const token = params.get('token');
                const refreshtoken = params.get('refreshtoken');

                if (!token || !refreshtoken) {
                    throw new Error('Credenciais incompletas.');
                }

                server.defaults.headers['Authorization'] = `Bearer ${token}`;
                const { data } = await server.get('auth');
                const credentials = {
                    token,
                    refreshtoken,
                    user: data.data,
                    club: params.get('club'),
                };

                const advertiserFlag = params.get('advertiser') === 'true' || Boolean(credentials.user?.Advertiser?.id);

                if (params.get('club')) {
                    await Login({
                        token: credentials.token,
                        refreshtoken: credentials.refreshtoken,
                        user: credentials.user,
                        club: credentials.club,
                    });
                } else if (advertiserFlag) {
                    await Login({
                        token: credentials.token,
                        refreshtoken: credentials.refreshtoken,
                        user: credentials.user,
                        advertiser: credentials.user?.Advertiser,
                    });
                } else {
                    await Login({
                        token: credentials.token,
                        refreshtoken: credentials.refreshtoken,
                        user: credentials.user,
                    });
                }
            } catch (error) {
                console.error('AuthRedirect:', error);
                setErrorMessage('Não foi possível validar o acesso. Faça login novamente.');
                navigation('/', { replace: true });
            }
        };

        authenticate();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Stack alignItems="center" justifyContent="center" width="100%" height="100%" spacing={1}>
            <Typography>{errorMessage || 'Carregando dados...'}</Typography>
        </Stack>
    );
}
